import MarkerText from '../../../../../components/inputs/MarkerText';
import { useSearchContext } from '../../../context/SettingsSearchContext';
import { SettingsElementType } from '../types';

export default function SettingsInfoElement(props: { element: SettingsElementType & { type: 'text' } }) {
    const context = useSearchContext();
    return (
        <div className="d-flex flex-column justify-content-center px-3">
            <MarkerText highlight={context.term}>{props.element.name}</MarkerText>
            <div>
                <MarkerText highlight={context.term} className="secondary-text">
                    {props.element.hint}
                </MarkerText>
            </div>
        </div>
    );
}
